module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAG1BMVEUAAAA3N0AzNzozNjsyNjozNzptcHPp6er///+lRvmYAAAABnRSTlMAHKbm/+1DRvRuAAAAOElEQVR4AWNgVHZBAkYCDKIuKCCQQSW9AwmUOTGYVCALtDszuHSgAJdBITAqgBFRGFGJEdkYyQEAezPtmz31ad4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/choose_many/assets/checkbox.png
// module id = 535
// module chunks = 0